<div class="tab-content">
    <div class="row">
      <div class="col-md-6">
        <div class="graph-wrapper">
          <div class="d-flex justify-content-between">
            <div>
              <div class="d-flex align-items-center">
                <img src="../../../assets/images/analytics-activation.svg" alt="">
                <h3 class="mb-0 ms-2">Story views</h3>
              </div>
              <div class="d-flex align-items-center mt-3">
                <h4 class="pe-3" style="border-right: 1px solid rgba(218, 218, 218, 1)">  <span>Event <br> count</span>  {{eventCount}}</h4>
                <h4 class="ps-3">  <span>Total <br> users</span> {{totalUsers}}</h4>
              </div>
            </div>
            <div>
              <select
                id="timeframe"
                [(ngModel)]="selectedTimeframeLine"
                (change)="updateChart()"
              >
                <option value="last-7-days">Last 7 days</option>
                <option value="last-30-days">Last 30 days</option>
                <option value="last-12-months">Last 12 months</option>
              </select>
            </div>
          </div>
    
          <div style="display: block">
            <canvas
              baseChart
              [datasets]="chartData"
              [labels]="chartLabels"
              [type]="chartType"
            >
            </canvas>
          </div>
        </div>
      </div>
  
      <div class="col-md-6">
        <div class="graph-wrapper">
          <div  class="d-flex justify-content-between">
            <div>
              <div class="d-flex align-items-center">
                <img src="../../../assets/images/HandPointing.svg" alt="">
                <h3 class="mb-0 ms-2">Business button tap</h3>
              </div>
              <div class="d-flex align-items-center mt-3">
                <h4 class="pe-3" style="border-right: 1px solid rgba(218, 218, 218, 1)"> <span>Event <br> count</span> {{eventCountBar}}</h4>
                <h4 class="ps-3"><span> Total <br> users</span> {{totalUsersBar}}</h4>
              </div>
            </div>
            <div>
              <select
                id="timeframe"
                [(ngModel)]="selectedTimeframeBar"
                (change)="updateBarChart()"
              >
                <option value="last-7-days">Last 7 days</option>
                <option value="last-30-days">Last 30 days</option>
                <option value="last-12-months">Last 12 months</option>
              </select>
            </div>
          </div>
    
  
          <div style="display: block">
            <canvas
              baseChart
              [datasets]="barChartData"
              [labels]="barChartLabels"
              [options]="barChartOptions"
              [type]="barChartType"
            >
            </canvas>
          </div>
        </div>
        </div>
  
        <div class="col-md-6">
          <div class="notification-wrapper">
            <div class="d-flex align-items-start">
              <div class="not-img me-3">
                <img src="../../../assets/images/notification-ring.svg" alt="">
              </div>
              <div>
                <h3>1389</h3>
                <h4>Total users</h4>
                <h5>Total number of users that interacted with the magnet</h5>
              </div>
            </div>
          </div>
        </div>
  
        <div class="col-md-6">
          <div class="notification-wrapper">
            <div class="d-flex align-items-start">
              <div class="not-img me-3" style="background: rgba(50, 206, 255, 1);">
                <img src="../../../assets/images/notification-ring.svg" alt="">
              </div>
              <div>
                <h3>1698</h3>
                <h4>Notification opened</h4>
                <h5>Number of notifications opened.</h5>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
  